import { useEffect, useRef, useState } from 'react';

function formatValue(current, target, format, prefix = '', suffix = '') {
  let out;
  if (format === 'compact') {
    if (current >= 1000000) out = prefix + (current / 1000000).toFixed(2) + 'M' + suffix;
    else if (current >= 1000) out = prefix + Math.round(current / 1000) + 'K' + suffix;
    else out = prefix + Math.round(current) + suffix;
  } else if (format === 'decimal') {
    out = prefix + current.toFixed(1) + suffix;
  } else if (format === 'number-comma') {
    out = prefix + Math.round(current).toLocaleString() + suffix;
  } else {
    out = prefix + Math.round(current) + suffix;
  }
  return out;
}

export function useCountUp(target, format = 'number', prefix = '', suffix = '', trigger = false) {
  const [display, setDisplay] = useState(prefix + '0' + suffix);
  const animated = useRef(false);

  useEffect(() => {
    if (!trigger || animated.current) return;
    animated.current = true;

    const duration = 1800;
    const steps = 50;
    const interval = duration / steps;
    let frame = 0;

    const timer = setInterval(() => {
      frame++;
      const ease = 1 - Math.pow(1 - frame / steps, 3);
      const current = target * ease;
      setDisplay(formatValue(current, target, format, prefix, suffix));

      if (frame >= steps) {
        clearInterval(timer);
        setDisplay(formatValue(target, target, format, prefix, suffix));
      }
    }, interval);

    return () => clearInterval(timer);
  }, [trigger, target, format, prefix, suffix]);

  return display;
}
